__turbopack_context__.v({
  "chevron": "index-module__EMlpeG__chevron",
  "control": "index-module__EMlpeG__control",
  "item": "index-module__EMlpeG__item",
  "label": "index-module__EMlpeG__label",
  "root": "index-module__EMlpeG__root",
});
